module.exports = __webpack_public_path__ + "0ab92ccc4fed101eaadbf513f908ab3b.mp3";